import $ from 'jquery'
import 'slick-carousel'

$(document).ready( initPartnersCarousel )

function initPartnersCarousel(){
  const $carousels = $('.js-partners-carousel')
  if (!$carousels.length) return

  $carousels.each(function() {
    const $carousel = $(this)
    $carousel.slick({
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      variableWidth: true,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false
    }).on("beforeChange", function(e, slick) {
      var width = $carousel.find('.slick-current').outerWidth();
      var speed = (width*3000)/200;
      $carousel.slick("setOption", "speed", speed);
    });
  })

  $('.js-partners__pause i.pause').on('click', function(i) {
    $(this).hide()
    $(this).next('i.play').show()
    $carousels.slick('pause')
  })

  $('.js-partners__pause i.play').on('click', function(i) {
    $(this).hide()
    $(this).prev('i.pause').show()
    $carousels.slick('play')
  })
}
